import { RestService, Rest } from '@abp/ng.core';
import type { PagedResultDto } from '@abp/ng.core';
import { Injectable, inject } from '@angular/core';
import type { GeneticMaterialCreateDto, GeneticMaterialDto, GeneticMaterialExcelDownloadDto, GeneticMaterialUpdateDto, GetGeneticMaterialsInputDto } from '../dtos/genetic-material/models';
import type { DownloadTokenResultDto, GetByIdsInputDto } from '../dtos/shared/models';

@Injectable({
  providedIn: 'root',
})
export class GeneticMaterialService {
  private restService = inject(RestService);
  apiName = 'General';
  

  create = (input: GeneticMaterialCreateDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, GeneticMaterialDto>({
      method: 'POST',
      url: '/api/general/geneticMaterials',
      body: input,
    },
    { apiName: this.apiName,...config });
  

  delete = (id: number, config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'DELETE',
      url: `/api/general/geneticMaterials/${id}`,
    },
    { apiName: this.apiName,...config });
  

  deleteByIds = (ids: number[], config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'DELETE',
      url: '/api/general/geneticMaterials',
      params: { ids },
    },
    { apiName: this.apiName,...config });
  

  get = (id: number, config?: Partial<Rest.Config>) =>
    this.restService.request<any, GeneticMaterialDto>({
      method: 'GET',
      url: `/api/general/geneticMaterials/${id}`,
    },
    { apiName: this.apiName,...config });
  

  getDownloadToken = (config?: Partial<Rest.Config>) =>
    this.restService.request<any, DownloadTokenResultDto>({
      method: 'GET',
      url: '/api/general/geneticMaterials/download-token',
    },
    { apiName: this.apiName,...config });
  

  getList = (input: GetGeneticMaterialsInputDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, PagedResultDto<GeneticMaterialDto>>({
      method: 'GET',
      url: '/api/general/geneticMaterials',
      params: { name: input.name, geneticMaterialTypeId: input.geneticMaterialTypeId, geneticMaterialTypeName: input.geneticMaterialTypeName, geneticMaterialOriginId: input.geneticMaterialOriginId, geneticMaterialOriginName: input.geneticMaterialOriginName, speciesId: input.speciesId, speciesName: input.speciesName, geneticMaterialCrossingId: input.geneticMaterialCrossingId, geneticMaterialCrossingName: input.geneticMaterialCrossingName, notes: input.notes, isCommercialMaterial: input.isCommercialMaterial, isThirdParty: input.isThirdParty, remsoftName: input.remsoftName, geneticMaterialGroupId: input.geneticMaterialGroupId, geneticMaterialGroupName: input.geneticMaterialGroupName, sanitaryClassificationId: input.sanitaryClassificationId, sorting: input.sorting, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName,...config });
  

  getListAsExcelFile = (input: GeneticMaterialExcelDownloadDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, Blob>({
      method: 'GET',
      responseType: 'blob',
      url: '/api/general/geneticMaterials/as-excel-file',
      params: { downloadToken: input.downloadToken, fields: input.fields, name: input.name, geneticMaterialTypeId: input.geneticMaterialTypeId, geneticMaterialTypeName: input.geneticMaterialTypeName, geneticMaterialOriginId: input.geneticMaterialOriginId, geneticMaterialOriginName: input.geneticMaterialOriginName, speciesId: input.speciesId, speciesName: input.speciesName, geneticMaterialCrossingId: input.geneticMaterialCrossingId, geneticMaterialCrossingName: input.geneticMaterialCrossingName, notes: input.notes, isCommercialMaterial: input.isCommercialMaterial, isThirdParty: input.isThirdParty, remsoftName: input.remsoftName, geneticMaterialGroupId: input.geneticMaterialGroupId, geneticMaterialGroupName: input.geneticMaterialGroupName, sanitaryClassificationId: input.sanitaryClassificationId, sorting: input.sorting, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName,...config });
  

  getListByIds = (input: GetByIdsInputDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, GeneticMaterialDto[]>({
      method: 'GET',
      url: '/api/general/geneticMaterials/by-ids',
      params: { ids: input.ids },
    },
    { apiName: this.apiName,...config });
  

  update = (id: number, input: GeneticMaterialUpdateDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, GeneticMaterialDto>({
      method: 'PUT',
      url: `/api/general/geneticMaterials/${id}`,
      body: input,
    },
    { apiName: this.apiName,...config });
}